import { useReducer, createContext, useState, useEffect } from "react";
import produce from "immer";
import {
  isCheckboxSelected,
  isUpgradeDisabled,
  isHeaterDisabled,
  isLidCoverDisabled,
  isLinerColorDisabled,
  isFlueDrainDisabled,
  isElectricalDisabled,
  isWoodenDisabled,
  isSeatingDisabled,
  isWaterCareDisabled, isWoodDisabled,
} from "./utils";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../../helpers/local-storage";
import {withCorrectPrice} from "../../../helpers/utils";
import sections from './sections.json'

const initialState = {
  size: undefined,
  heaters: {
    heater: undefined,
    upgrades: [],
  },
  interiorexterior: {
    wood: undefined,
    woodTreatment: [],
    liner: [],
    linerColor: undefined,
    seating: undefined,
    lidCover: undefined,
  },
  accessories: {
    flueDrain: [],
    electrical: [],
    wooden: [],
    waterCare: [],
  },
};

const toggleCheckbox = (options, option, checked) => {
  const optionIndex = options.findIndex((upgrade) => upgrade.id === option.id);

  if (checked && optionIndex < 0) {
    options.push(option);
  }

  if (checked && optionIndex >= 0) {
    options.splice(optionIndex, 1, option);
  }

  if (!checked && optionIndex >= 0) {
    options.splice(optionIndex, 1);
  }
};

export const reducer = produce((draft, action) => {
  switch (action.type) {
    case "SELECT_SIZE": {
      draft.size = action.payload;

      if (isHeaterDisabled(draft.heaters.heater, action.payload)) {
        draft.heaters.heater = undefined;
      }

      if (draft.size.id !== 3) {
        draft.interiorexterior.seating = sections[2].fields.seating.options[0];
      } else {
        draft.interiorexterior.liner = [];
        draft.interiorexterior.seating = undefined;
      }

      if (isLinerColorDisabled(draft.interiorexterior.liner, draft.size)) {
        draft.interiorexterior.linerColor = undefined;
      }

      const wrongWoodWasSelected = (draft.interiorexterior.wood?.id === 3 || draft.interiorexterior.wood?.id === 4) && draft.size !==3
      if (wrongWoodWasSelected) {
        draft.interiorexterior.wood = undefined
      }

      if (
        isLidCoverDisabled(
          draft.interiorexterior.lidCover,
          draft.interiorexterior.size, draft.heaters.upgrades
        )
      ) {
        draft.interiorexterior.lidCover = undefined;
      }

      const wooden = draft.accessories.wooden;
      draft.accessories.wooden = wooden.filter(
        (item) =>
          isCheckboxSelected(item, wooden) &&
          !isWoodenDisabled(
            item,
            draft.interiorexterior.liner,
            draft.interiorexterior.lidCover,
            draft.size
          )
      );

      const electrical = draft.accessories.electrical;
      draft.accessories.electrical = electrical.filter(
        (item) =>
          isCheckboxSelected(item, electrical) &&
          !isElectricalDisabled(
            item,
            draft.accessories.electrical,
            draft.interiorexterior.liner,
            draft.size
          )
      );
      break;
    }
    case "SELECT_HEATER": {
      const heater = action.payload.option
      draft.heaters.heater = heater
      const upgrades = draft.heaters.upgrades;

      draft.heaters.upgrades = upgrades.filter(
          (upgrade) =>
              isCheckboxSelected(upgrade, upgrades) &&
              !isUpgradeDisabled(upgrade, action.payload.option)
      );

      if (isLidCoverDisabled(draft.interiorexterior.lidCover, draft.size, action.payload.option, action.payload.upgrades)) {
        draft.interiorexterior.lidCover = undefined;
      }

      const flueDrain = draft.accessories.flueDrain;
      draft.accessories.flueDrain = flueDrain.filter(
          (item) =>
              isCheckboxSelected(item, flueDrain) &&
              !isFlueDrainDisabled(item, action.payload.option)
      );

      const selectedUpgrades = [...action.payload.upgrades].filter((upr) => {
        return (upr.id === 1 && heater?.id === 2) || (upr.id === 2 && heater !== undefined && !isUpgradeDisabled(upr, heater))
      })

      if (heater.id === 1 || selectedUpgrades.length) {
        draft.heaters.upgrades = []
      }

      if (selectedUpgrades.length) {
        selectedUpgrades.forEach(upg => {
          if (upg.variations) {
            const item = {
              ...upg.variations[0],
              id: upg.id,
              label: upg.label,
              variant: upg.variations[0].label,
            }
            draft.heaters.upgrades.push(item)
          } else {
            draft.heaters.upgrades.push(upg)
          }
        })
      }

      break;
    }
    case "SELECT_HEATER_UPGRADE": {
      const { checked, option } = action.payload;
      toggleCheckbox(draft.heaters.upgrades, option, checked);
      if (isLidCoverDisabled(draft.interiorexterior.lidCover, draft.size,draft.heaters.heater, draft.heaters.upgrades)) {
        draft.interiorexterior.lidCover = undefined;
      }
      break;
    }
    case "SELECT_WOOD": {
      draft.interiorexterior.wood = action.payload;

      break;
    }
    case "SELECT_WOOD_TREATMENT": {
      const { checked, option } = action.payload;
      toggleCheckbox(draft.interiorexterior.woodTreatment, option, checked);
      break;
    }
    case "SELECT_LINER": {
      const { checked, option, wood, woodOptions } = action.payload;
      toggleCheckbox(draft.interiorexterior.liner, option, checked);
      const toggleWood = wood && !checked && (wood.id === 3 || wood.id === 4)

      if (toggleWood) {
        draft.interiorexterior.wood = woodOptions[0]
      }

      if (isLinerColorDisabled(draft.interiorexterior.liner, draft.size)) {
        draft.interiorexterior.linerColor = undefined;
      }

      if (
        isSeatingDisabled(
          draft.interiorexterior.seating,
          draft.interiorexterior.liner
        )
      ) {
        draft.interiorexterior.seating = undefined;
      }

      const electrical = draft.accessories.electrical;
      draft.accessories.electrical = electrical.filter(
        (item) =>
          isCheckboxSelected(item, electrical) &&
          !isElectricalDisabled(
            item,
            draft.accessories.electrical,
            draft.interiorexterior.liner,
            draft.size
          )
      );

      const wooden = draft.accessories.wooden;
      draft.accessories.wooden = wooden.filter(
        (item) =>
          isCheckboxSelected(item, wooden) &&
          !isWoodenDisabled(
            item,
            draft.interiorexterior.liner,
            draft.interiorexterior.lidCover,
            draft.size
          )
      );

      break;
    }
    case "SELECT_LINER_COLOR": {
      draft.interiorexterior.linerColor = action.payload;
      break;
    }
    case "SELECT_SEATING": {
      draft.interiorexterior.seating = action.payload;
      break;
    }
    case "SELECT_LID_COVER": {
      draft.interiorexterior.lidCover = action.payload;

      const wooden = draft.accessories.wooden;
      draft.accessories.wooden = wooden.filter(
        (item) =>
          isCheckboxSelected(item, wooden) &&
          !isWoodenDisabled(
            item,
            draft.interiorexterior.liner,
            draft.interiorexterior.lidCover,
            draft.size
          )
      );
      break;
    }
    case "SELECT_FLUE_DRAIN": {
      const { checked, option } = action.payload;
      toggleCheckbox(draft.accessories.flueDrain, option, checked);
      break;
    }
    case "SELECT_ELECTRICAL": {
      const { checked, option } = action.payload;
      toggleCheckbox(draft.accessories.electrical, option, checked);

      if (checked && option.id === 2) {
        const filtered = draft.accessories.electrical.filter(
          (item) => item?.variant !== "2.2kW with 10 jets"
        );

        draft.accessories.electrical = filtered;
      }
      break;
    }
    case "SELECT_WOODEN": {
      const { checked, option } = action.payload;
      toggleCheckbox(draft.accessories.wooden, option, checked);
      break;
    }
    case "SELECT_WATER_CARE": {
      const { checked, option } = action.payload;
      toggleCheckbox(draft.accessories.waterCare, option, checked);

      const waterCare = draft.accessories.waterCare;
      draft.accessories.waterCare = waterCare.filter(
        (item) =>
          isCheckboxSelected(item, waterCare) &&
          !isWaterCareDisabled(item, draft.accessories.waterCare)
      );
      break;
    }
    default:
      break;
  }
});

export const ConfigurationContext = createContext(initialState);
export const DispatchContext = createContext(undefined);

export const ConfigurationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    reducer,
    getLocalStorage("ofuroConfiguration", initialState)
  );

  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    let total =
        (withCorrectPrice(state.size)) +
        (withCorrectPrice(state.heaters.heater)) +
        state.heaters.upgrades.reduce((acc, cur) => acc + (withCorrectPrice(cur)), 0) +
        (withCorrectPrice(state.interiorexterior.wood)) +
        state.interiorexterior.woodTreatment.reduce(
            (acc, cur) => acc + (withCorrectPrice(cur)),
            0
        ) +
        (withCorrectPrice(state.interiorexterior.linerColor)) +
        (withCorrectPrice(state.interiorexterior.lidCover)) +
        state.accessories.flueDrain.reduce(
            (acc, cur) => acc + (withCorrectPrice(cur)),
            0
        ) +
        state.interiorexterior.liner.reduce(
            (acc, cur) => acc + (withCorrectPrice(cur)),
            0
        ) +
        withCorrectPrice(state.interiorexterior.seating) +
        state.accessories.electrical.reduce(
            (acc, cur) => acc + (withCorrectPrice(cur)),
            0
        ) +
        state.accessories.wooden.reduce(
            (acc, cur) => acc + (withCorrectPrice(cur)),
            0
        ) +
        state.accessories.waterCare.reduce(
            (acc, cur) => acc + (withCorrectPrice(cur)),
            0
        );

    if((state?.size?.id === 3 || state?.interiorexterior.wood?.id === 3 || state?.interiorexterior.wood?.id === 4) && state.interiorexterior.liner[0]) {
      total = total - state.interiorexterior.liner[0].price
    }

    setTotalPrice(total);
    setLocalStorage("ofuroConfiguration", state);
  }, [state]);

  return (
    <ConfigurationContext.Provider value={{ ...state, totalPrice }}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </ConfigurationContext.Provider>
  );
};
